import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    line-height: 24px;
    text-decoration-line: underline;
    color: ${theme?.colour?.secondary};

    cursor: pointer;

    &:hover {
      color: ${theme?.colour?.primary};
    }
  `}
`;
export default Atom({ type: 'button', dataType: 'string', template })